/* MUI */
import { Button, FormLabel, Grid, TextField } from '@mui/material';
import { ColorPicker } from 'application/Shared/Components/Pickers';
// Modals are imported directly here due to a circular dependency.
import { ModalBody } from 'application/Shared/Modals/Components/ModalBody';
import { ModalFooter } from 'application/Shared/Modals/Components/ModalFooter';

/*  React  */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const AddNewTagModalBody = ({
    isEditing,
    onClose,
    onCreate,
    tagDefaultValues = {}
}) => {
    const { t } = useTranslation();

    // For partner and clients, the name field of a tag should not be editable.
    // For global global admins, it should be editable, but only as far as changing the case sensitivity of the tag.
    // The name itself must be the same from a case-insensitive standpoint.
    // TODO SAAS-1395: Add validation for global admin. Probably best to convert to react-hook-form.
    const disableNameField = !!tagDefaultValues?.name;

    const [name, setName] = useState(tagDefaultValues?.name || '');
    const [description, setDescription] = useState(
        tagDefaultValues?.description || ''
    );
    const [color, setColor] = useState(
        tagDefaultValues?.color || 'tag.option1'
    );

    const disableSubmit = !name?.trim();

    return (
        <>
            <ModalBody style={{ marginTop: '16px' }}>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <FormLabel component="label">
                            {t('Common.name')}
                        </FormLabel>
                        <TextField
                            autoFocus
                            disabled={disableNameField}
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                            placeholder={t('Common.name')}
                            required
                            value={name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel component="label">
                            {t('Common.color')}
                        </FormLabel>

                        {/*
                            TODO: update this to show the actual color in the select
                            OR use a new component...?
                        */}

                        <ColorPicker
                            multiple={false}
                            disableAllOption
                            value={color}
                            onChange={setColor}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormLabel component="label">
                            {t('Common.description')}
                        </FormLabel>
                        <TextField
                            fullWidth
                            onChange={(e) => setDescription(e.target.value)}
                            type="text"
                            value={description}
                        />
                    </Grid>
                </Grid>
            </ModalBody>
            <ModalFooter>
                <Button
                    data-trackid={
                        isEditing
                            ? 'globalTag_add_save_cancel'
                            : 'globalTag_add_create_cancel'
                    }
                    onClick={onClose}
                    color="secondary"
                    variant="contained"
                >
                    {t('Common.cancel')}
                </Button>
                <Button
                    data-trackid={
                        isEditing
                            ? 'globalTag_add_save'
                            : 'globalTag_add_create'
                    }
                    variant="contained"
                    disabled={disableSubmit}
                    onClick={() =>
                        onCreate({
                            color,
                            description,
                            name
                        })
                    }
                    color="primary"
                >
                    {isEditing ? t('Common.save') : t('Common.create')}
                </Button>
            </ModalFooter>
        </>
    );
};
